import { AuditableEntity } from "./audible-entity.model";
import { ContractBase } from "./contract-base.model";
import { EANCode } from "./ean-code.model";

export class ElectricityContract extends AuditableEntity {

    constructor(_Id?: number, _ContractBaseId?: number, _Endex?: number, _IsActive?: boolean,
        _Note?: string, _NoticePeriod?: number, _TariffExclNightConsumption?: number,
        _TariffFixed?: number, _TariffLowConsumption?: number, _TariffPeakConsumption?: number,
        _TariffRenewableEnergy?: number, _TariffSingleUse?: number, _EANCodeId?: number,
        _CreatedBy?: string, _CreatedDate?: Date, _UpdatedBy?: string, _UpdatedDate?: Date,
        _DeletedBy?: string, _DeletedDate?: Date, _ContractBaseIds?: string, _FileCount?: number,
        _ECType?: string, _CType?: string) {

        super(_CreatedBy, _CreatedDate, _UpdatedBy, _UpdatedDate, _DeletedBy, _DeletedDate);

        this.Id = _Id || 0;
        this.ContractBaseId = _ContractBaseId;
        this.Endex = _Endex;
        this.IsActive = _IsActive || true;
        this.Note = _Note;
        this.NoticePeriod = _NoticePeriod;
        this.TariffExclNightConsumption = _TariffExclNightConsumption;
        this.TariffFixed = _TariffFixed;
        this.TariffLowConsumption = _TariffLowConsumption;
        this.TariffPeakConsumption = _TariffPeakConsumption;
        this.TariffRenewableEnergy = _TariffRenewableEnergy;
        this.TariffSingleUse = _TariffSingleUse;
        this.EANCodeId = _EANCodeId;

        this.ContractBase = new ContractBase();
        this.EANCode = new EANCode();

        this.SourceEanCodes = new Array<EANCode>();
        this.TargetEanCodes = new Array<EANCode>();
        this.ContractBaseIds = _ContractBaseIds;
        this.FileCount = _FileCount;
        this.ECType = _ECType;
        this.CType = _CType;
    }

    public Id: number;
    public ContractBaseId: number;
    public Endex: number;
    public IsActive: boolean;
    public Note: string;
    public NoticePeriod: number;
    public TariffExclNightConsumption: number;
    public TariffFixed: number;
    public TariffLowConsumption: number;
    public TariffPeakConsumption: number;
    public TariffRenewableEnergy: number;
    public TariffSingleUse: number;
    public EANCodeId: number;
    public ECType: string;
    public CType: string = 'B';
    public ContractBase: ContractBase;
    public EANCode: EANCode;

    public SourceEanCodes: EANCode[];
    public TargetEanCodes: EANCode[];

    public ContractBaseIds: string;
    public FileCount: number;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/electricity-contract.model.ts